import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setAuthData } from './store/slices/authSlice';
import { AppRoutes } from './routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    // بازیابی وضعیت احراز هویت از localStorage
    const key = localStorage.getItem('key');
    const phoneNumber = localStorage.getItem('phoneNumber');
    
    if (key && phoneNumber) {
      dispatch(setAuthData({
        key,
        phoneNumber,
        isAuthenticated: true
      }));
    }
  }, [dispatch]);

  return (
    <div className="app">
      <AppRoutes />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
